import React from 'react';
import PropTypes from 'prop-types';

const ExpandIcon = ({color = '#B1BAC2', width = 'auto', height = 'auto', className = ''}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 32 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>expand-30px</title>

    <g>
      <g fill={color} fillRule="nonzero">
        <polygon id="Path" points="16 19.9628541 32 3.96097331 28.0371459 0 16 12.0352651 3.96097331 0 0 3.96097331" />
      </g>
    </g>
  </svg>
);

ExpandIcon.propTypes = {
  /** The class name of the expand icon. */
  className: PropTypes.string,

  /** The color of the expand icon. */
  color: PropTypes.string,

  /** The width of the expand icon. */
  width: PropTypes.string,

  /** The height of the expand icon. */
  height: PropTypes.string,
};

export default ExpandIcon;
